import { Component } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { AuthentificationService } from './authentification.service';

@Component({
  template: `
  <div id="acces-interdit">
    <h3 class="h5">Accès interdit</h3>
    <p>
      Vous avez bien été authentifié(e), mais vous n'avez pas les droits nécessaires pour consulter la page demandée. <br>
    </p>
    <p>
      Si vous avez utilisé un lien reçu par mail et que vous n'avez toujours pas le droit d'accéder à l'application,
      <a href="mailto:enquetes-electroniques.ssmjustice@justice.gouv.fr?Subject=Enquête%20Aav">
        merci de prendre contact avec la Section Enquêtes du SSER
      </a>.
    </p>

    <button type="button" class="btn btn-primary" aria-label="Retour à la page d'authentification" (click)="retourAuthentification()">
      <i class="material-icons">arrow_back</i> Retour à la page d'authentification
    </button>

  </div>
  `,
  styles: [`
  #acces-interdit{
    margin: 15px 25px;
    max-width: 800px;
  }

  p{ margin: 20px 0; }
  .exemple-url{
    display: inline-block;
    margin-left: 20px;
    font-family: monospace;
  }
  strong{ color: #00f; }

  .exemple-authentification{
    display: inline-block;  /*Permet de faire en sorte que le div soit le plus petit possible par rapport à son contenu*/
    background-color: #ccc;
  }
  img { padding: 25px; }
  `]
})
export class ForbiddenComponent {

  constructor(private router: Router, private authService: AuthentificationService) {}

  async retourAuthentification(): Promise<void> {
    // On supprime du local storage les informations issues de l'authentification passée, afin de pouvoir se ré-authentifier.
    this.authService.logout();

    const jetonElst = await this.authService.getIelst() as string;
    if ( jetonElst ) {
      const navigationExtras: NavigationExtras = {
        queryParams: { 'jetonElst': jetonElst }
      };
      this.router.navigate(['/authentification'], navigationExtras);
    } else {
      this.router.navigate(['/authentification']);
    }

  }
}
